






































































































/* eslint-disable @typescript-eslint/camelcase */
import {
  defineComponent,
  computed,
  watch,
  reactive,
  ref,
  Ref,
  h
} from '@vue/composition-api'
import { useRouter } from '@u3u/vue-hooks'
import { numberWithCommas } from '@/lib/utils'
import { useAxios } from '@vue-composable/axios'
import { useAuth } from '@/composables/useAuth'
import { useApp } from '@/composables/useApp'
import { AxiosBasicCredentials } from 'axios'
import { toDateString } from '@/lib/utils'
import fileDownload from 'js-file-download'
import { Switch as Toggle } from 'ant-design-vue'
import Vue from 'vue'

export default defineComponent({
  components: {
    Toggle
  },

  setup(_, { root }) {
    const { currentApp } = useApp()
    const { username, userToken } = useAuth()
    const auth = {
      username: username.value,
      password: userToken.value
    } as AxiosBasicCredentials

    const { route, router } = useRouter()
    const pageSize = 10
    const current = +(route.value.query['current'] ?? 1)

    const params = reactive({
      page: current,
      // eslint-disable-next-line
      campaign_id: route.value.params['id'],
      // eslint-disable-next-line
      page_size: pageSize
    })

    const { data: result, loading, error, exec } = useAxios()
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const updated: Ref<any> = ref({})
    watch(
      () => params,
      params => {
        exec({
          url: `${currentApp.value.voidApiUri}/admin/coupons`,
          method: 'GET',
          params,
          auth
        })
      },
      { immediate: true, deep: true }
    )

    watch(
      error,
      error => {
        if (error) {
          console.error(error)
          root.$notification.error({
            message: 'Error',
            description: 'An error occurred'
          })
        }
      },
      { immediate: true }
    )

    const data = computed(() => {
      const data = result.value
      if (data == null) {
        return { coupons: [], campaign: {}, pagination: {} }
      }
      const pagination = {
        total: data.pagination.total_entries,
        pageSize: data.pagination.page_size,
        current: data.pagination.page_number
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const coupons = data.data.map((record: any) => {
        if (updated.value[record.code] == null) {
          return record
        }
        return updated.value[record.code]
      })
      return {
        coupons,
        campaign: data.meta.campaign,
        pagination
      }
    })

    const colRenderer = (data: string) =>
      h(
        'span',
        {
          class: data ? null : 'italic text-gray-500'
        },
        data ? data : 'N/A'
      )

    const columns = [
      {
        title: 'code',
        dataIndex: 'code',
        align: 'center'
      },
      {
        title: 'applicable user type',
        dataIndex: 'applicable_user_type',
        customRender: colRenderer
      },
      {
        title: 'type',
        dataIndex: 'coupon_type',
        scopedSlots: { customRender: 'couponType' }
      },
      {
        title: 'duration (days)',
        dataIndex: 'duration',
        customRender: colRenderer
      },
      {
        title: 'price',
        dataIndex: 'fee',
        scopedSlots: { customRender: 'fee' }
      },
      {
        title: 'price category',
        dataIndex: 'fixed_price_category',
        customRender: colRenderer
      },
      {
        title: 'discount percent',
        dataIndex: 'discount_percentage',
        scopedSlots: { customRender: 'discount' }
      },
      {
        title: 'max usage',
        dataIndex: 'max_usage',
        customRender: colRenderer
      },
      {
        title: 'number of usage',
        dataIndex: 'num_of_usage',
        customRender: colRenderer
      },
      {
        title: 'valid from',
        dataIndex: 'valid_from',
        scopedSlots: { customRender: 'date' }
      },
      {
        title: 'valid until',
        dataIndex: 'valid_til',
        scopedSlots: { customRender: 'date' }
      },
      {
        title: 'enabled',
        dataIndex: 'enabled',
        scopedSlots: { customRender: 'onOff' }
      },
      {
        title: 'created at',
        dataIndex: 'inserted_at',
        scopedSlots: { customRender: 'date' }
      }
    ]

    const handleTableChange = ({ current }: { current: number }) => {
      router.push({
        path: route.value.path,
        query: { ...route.value.query, current: `${current}` }
      })
      params.page = current
    }

    const {
      data: exportedData,
      loading: isExporting,
      error: exportError,
      exec: exportExec
    } = useAxios()

    watch(
      exportError,
      error => {
        if (error) {
          console.error(error)
          root.$notification.error({
            message: 'Error',
            description: 'An error occurred during export'
          })
        }
      },
      { immediate: true }
    )
    watch(
      exportedData,
      data => {
        if (data == null) {
          return
        }
        fileDownload(data, `coupons-${route.value.params['id']}.csv`)
      },
      { immediate: true }
    )

    const exportToExcel = () => {
      exportExec({
        url: `${currentApp.value.voidApiUri}/admin/coupons/export`,
        method: 'POST',
        responseType: 'blob',
        // eslint-disable-next-line @typescript-eslint/camelcase
        params: { campaign_id: route.value.params['id'] },
        auth
      })
    }

    const breadcrumbRoutes = computed(() => [
      {
        path: '/griddiary/marketing/campaigns',
        breadcrumbName: 'Campaigns'
      },
      {
        path: `/griddiary/marketing/campaigns/${route.value.params['id']}`,
        breadcrumbName: data.value.campaign.name
      }
    ])

    const {
      // loading: toggling,
      data: toggleData,
      error: toggleError,
      exec: execToggle
    } = useAxios()

    const toggle = (code: string, enabled: boolean) =>
      execToggle({
        url: `${currentApp.value.voidApiUri}/admin/coupons/${code}/toggle`,
        method: 'POST',
        params: { enabled },
        auth
      })

    watch(
      toggleError,
      error => {
        if (error) {
          console.error(error)
          root.$notification.error({
            message: 'Error',
            description: 'An error occurred'
          })
        }
      },
      { immediate: true }
    )

    watch(toggleData, result => {
      if (result == null || result.data == null) {
        return
      }

      Vue.set(updated.value, result.data.code, result.data)
    })

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleToggle = (checked: boolean, record: any) => {
      toggle(record.code, checked)
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleSwitchClick = (_: boolean, event: any) => {
      event.stopPropagation()
    }

    const couponTypeClass = {
      extension: ['bg-teal-200', 'text-teal-600'],
      discount: ['bg-purple-200', 'text-purple-600'],
      fixed_price: ['bg-pink-200', 'text-pink-600']
    }

    return {
      numberWithCommas,

      breadcrumbRoutes,

      handleTableChange,

      loading,
      data,
      columns,

      toDateString,

      exportToExcel,
      isExporting,

      handleToggle,
      handleSwitchClick,

      couponTypeClass
    }
  }
})
